import React, { useState, useCallback } from 'react';
import { EdgeProps, getSmoothStepPath, useReactFlow } from 'reactflow';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './styles';

const CustomEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { deleteElements } = useReactFlow();

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 16,
  });

  const isError = data?.isError;
  const isCanvasDisabled = data?.isCanvasDisabled || false;
  const isHighlighted = selected || (isHovered && !isCanvasDisabled);

  const deleteButtonX = labelX - 17.5;
  const deleteButtonY = labelY - 17.5;

  const handleDeleteClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
    deleteElements({ edges: [{ id }] });
  }, [deleteElements, id]);

  const handleMouseEnter = useCallback(() => {
    if (!isCanvasDisabled) {
      setIsHovered(true);
    }
  }, [isCanvasDisabled]);

  const handleMouseLeave = useCallback(() => {
    if (!isCanvasDisabled) {
      setIsHovered(false);
    }
  }, [isCanvasDisabled]);

  return (
    <g onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={30}
        className="react-flow__edge-interaction"
        style={{ cursor: isCanvasDisabled ? 'default' : 'pointer' }}
      />
      <path
        id={id}
        style={{
          ...style,
          stroke: isError ? '#FF4C4C' : '#A3A3A3',
          strokeWidth: isHighlighted ? 2.5 : 1.5,
          cursor: isCanvasDisabled ? 'default' : 'pointer',
          strokeDasharray: isHighlighted ? '5,5' : 'none',
          pointerEvents: 'none',
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />

      {isHighlighted && !isCanvasDisabled && (
        <foreignObject
          width={35}
          height={35}
          x={deleteButtonX}
          y={deleteButtonY}
          className="edge-delete-button"
          requiredExtensions="http://www.w3.org/1999/xhtml"
          style={{ pointerEvents: 'auto' }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          }}>
            <IconButton
              size="small"
              onClick={handleDeleteClick}
              sx={styles.actionIcon}
            >
              <DeleteIcon sx={{ color: '#6F7287', fontSize: 24 }} />
            </IconButton>
          </div>
        </foreignObject>
      )}
    </g>
  );
};

export default CustomEdge;
